<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Projectos" pageTitle="Projectos" />
            <ProjectsContent />
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader';
import PageTitle from '../Common/PageTitle';
import ProjectsContent from '../Projects/ProjectsContent';
import FooterArea from '../Layouts/FooterArea';

export default {
    name: 'ProjectsPage',
    components: { MainHeader, PageTitle, ProjectsContent, FooterArea },
    mounted() { document.body.classList.add('body-bg-f8faff'); },
};
</script>
